import React from 'react';
import { useNavigate } from 'react-router-dom';

const VERTICAL_LOGO = process.env.PUBLIC_URL + '/vertical-logo.svg';

export default function PrivacyPolicyPage() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', fontFamily: 'system-ui, -apple-system, sans-serif' }}>

      {/* ── Nav ── */}
      <nav style={{
        position: 'sticky', top: 0, zIndex: 100,
        background: 'white', borderBottom: '1px solid #e5e7eb',
        padding: '0 40px', height: 64,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}>
          <img src={VERTICAL_LOGO} alt="ClockEarnings" style={{ height: 32 }}/>
        </button>
        <button
          onClick={() => navigate('/')}
          style={{
            padding: '8px 18px', background: 'linear-gradient(135deg, #22c55e 0%, #0f4d2e 100%)',
            color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer',
            fontWeight: 700, fontSize: 14,
          }}
        >
          Back to Home
        </button>
      </nav>

      {/* ── Content ── */}
      <main style={{ maxWidth: 760, margin: '0 auto', padding: '60px 24px 100px' }}>

        <h1 style={{ fontSize: 36, fontWeight: 800, color: '#111827', marginBottom: 8 }}>
          Privacy Policy
        </h1>
        <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 48 }}>Last updated: June 9, 2025</p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>

          <p style={bodyStyle}>
            This Privacy Policy describes how <strong>Clock Earnings by Flurry Systems</strong> ("we") collects,
            uses, and protects your data on our website{' '}
            <a href="https://www.clockearnings.com/" style={linkStyle}>https://www.clockearnings.com/</a>.
          </p>

          <section>
            <h2 style={h2Style}>1. Data We Collect</h2>
            <p style={bodyStyle}>We collect the following data:</p>
            <ul style={ulStyle}>
              <li style={liStyle}><strong>Name</strong></li>
              <li style={liStyle}><strong>Email</strong></li>
            </ul>
          </section>

          <section>
            <h2 style={h2Style}>2. Use of Data</h2>
            <p style={bodyStyle}>
              Collected data is used to provide services, improve the website, and for analytics purposes.
            </p>
          </section>

          <section>
            <h2 style={h2Style}>3. Data Protection</h2>
            <p style={bodyStyle}>
              We implement technical and organizational measures to protect your data.
            </p>
          </section>

          <section>
            <h2 style={h2Style}>4. Sharing Data with Third Parties</h2>
            <p style={bodyStyle}>
              We do not share your data with third parties, except as required by law.
            </p>
          </section>

          <section>
            <h2 style={h2Style}>5. Your Rights</h2>
            <p style={bodyStyle}>
              You may request access, correction, or deletion of your data by contacting us at:{' '}
              <a href="mailto:contact@flurrysystems.com" style={linkStyle}>contact@flurrysystems.com</a>.
            </p>
          </section>

          <section>
            <h2 style={h2Style}>6. Contact Us</h2>
            <p style={bodyStyle}>
              If you have any questions, please contact us at:{' '}
              <a href="mailto:contact@flurrysystems.com" style={linkStyle}>contact@flurrysystems.com</a>.
            </p>
          </section>

        </div>
      </main>

      {/* ── Footer ── */}
      <footer style={{
        borderTop: '1px solid #e5e7eb', padding: '24px 40px',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        flexWrap: 'wrap', gap: 16, background: 'white',
      }}>
        <img src={VERTICAL_LOGO} alt="ClockEarnings" style={{ height: 28 }}/>
        <span style={{ fontSize: 13, color: '#9ca3af' }}>© {new Date().getFullYear()} ClockEarnings by Flurry Systems</span>
      </footer>
    </div>
  );
}

const h2Style = {
  fontSize: 20, fontWeight: 700, color: '#111827',
  marginBottom: 12, paddingBottom: 8,
  borderBottom: '2px solid #22c55e', display: 'inline-block',
};

const bodyStyle = {
  fontSize: 16, lineHeight: 1.75, color: '#374151', margin: 0,
};

const linkStyle = {
  color: '#16a34a', fontWeight: 600, textDecoration: 'none',
};

const ulStyle = {
  margin: '12px 0 0', paddingLeft: 24, display: 'flex', flexDirection: 'column', gap: 6,
};

const liStyle = {
  fontSize: 16, lineHeight: 1.75, color: '#374151',
};
